export const LOADING_SCREENS = {
  CONTEXT_SWITCH: 'CONTEXT_SWITCH',
};

export const TOAST = {
  CONTEXT_SWITCH: 'CONTEXT_SWITCH',
};

export const MATCH_COMPANY_IDS = {
  ALTMAN_SOLON: 420,
};
